var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"icon-right":_vm.icon,"type":_vm.type,"inverted":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }